export default "__VITE_ASSET__L4emPm40__"